import dayjs from "dayjs";
import React from "react";
import { Event } from "../lib/types";

import { Box } from "../../shared/components/ui/chakra";
import { Flex, Grid, GridItem, HStack, Link, Show, Stack, Text } from "@chakra-ui/react";

const PointInfo = ({ event }: { event: Event }) => {
  return (
    <Box>
      <Grid
        gridTemplateAreas={{
          base: `
            "point-info"
            "event-word"
            "event-link"
          `,
          sm: `
            ". event-word"
            "point-info event-link"
          `,
        }}
        gridTemplateColumns={{ base: "1fr", sm: "auto 1fr" }}
        columnGap={3}
      >
        <GridItem area="event-word">
          {event.within_calculation_period && (
            <HStack color="primary" justifyContent="center" fontSize="xs">
              <Box>＼</Box>
              <Box>イベント参加中</Box>
              <Box>／</Box>
            </HStack>
          )}
        </GridItem>
        <GridItem mt={0.5} area="point-info">
          <Flex
            alignItems="stretch"
            minW={{ base: "initial", sm: "184px" }}
            maxW={{ base: "220px", sm: "184px" }}
            p={2}
            bgColor="brand.200"
            justifyContent="center"
            mx="auto"
            borderRadius={4}
            gap={2}
            position="relative"
            mb={{ base: 3, sm: 0 }}
          >
            <Show above="sm">
              <Box
                w={0}
                h={0}
                borderLeft="6px solid var(--chakra-colors-brand-200)"
                borderTop="5px solid transparent"
                borderBottom="5px solid transparent"
                position="absolute"
                right="-6px"
                top="calc(50% - 5px)"
              />
            </Show>
            <Show below="sm">
              <Box
                w={0}
                h={0}
                borderTop="6px solid var(--chakra-colors-brand-200)"
                borderLeft="5px solid transparent"
                borderRight="5px solid transparent"
                position="absolute"
                bottom="-6px"
                left="calc(50% - 5px)"
              />
            </Show>
            <Box textAlign="center" flex={1} px={1} pt={0.5}>
              <Box fontSize="sm" fontWeight="bold" lineHeight={1}>
                イベント
              </Box>
              <Box fontSize="10px">獲得数</Box>
              <Box
                w="full"
                fontSize="10px"
                py={0.5}
                bg={event.confirmed ? "primary" : "gray.base"}
                color="white"
                fontWeight="bold"
                borderRadius={2}
                mt={1}
              >
                {event.confirmed ? "確定" : "集計中"}
              </Box>
            </Box>
            <Stack
              flex={1}
              pt={{ base: 1, sm: 2 }}
              pb={1.5}
              px={{ base: 3, sm: 4 }}
              bgColor="white"
              borderRadius={4}
              justifyContent="center"
            >
              <Stack
                direction={{ base: "row", sm: "column" }}
                alignItems={{ base: "flex-end", sm: "initial" }}
                justifyContent={{ base: "right", sm: "initial" }}
                gap={{ base: 2, sm: 0 }}
                textAlign="center"
              >
                <Box
                  fontSize={{ base: "lg", sm: "2xl" }}
                  fontWeight="bold"
                  fontFamily="Open Sans"
                  lineHeight={{ base: "inherit", sm: 1 }}
                >
                  {event.point.toLocaleString()}
                </Box>
                <Box fontSize="10px" color="gray">
                  Loop
                </Box>
              </Stack>
            </Stack>
          </Flex>
        </GridItem>
        <GridItem
          textAlign="center"
          bgColor="brand.50"
          area="event-link"
          pt={2.5}
          pb={2}
          px={3}
          borderRadius={4}
          as={Flex}
          justifyContent="center"
          alignItems="center"
        >
          <Box>
            <Link display="block" fontSize="xs" href={event.url}>
              {event.name}
            </Link>
            <Box color="gray" fontSize="10px">
              {dayjs(event.calculation_finished_at).format("YYYY/MM/DD")}まで
            </Box>
          </Box>
        </GridItem>
      </Grid>
      {!event.confirmed && (
        <Box mt={2} as={Flex} justifyContent={{ base: "right", sm: "initial" }}>
          <Box color="textLink" as="span">
            *
          </Box>
          <Text fontSize="xs" color="textGray" ml={0.5}>
            イベント終了後に正式なLoopポイントが確定します。
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default PointInfo;
